import { saveSettings } from '@capital-access/common/user';
import { APPLICATION_SUGGESTER_KEY } from '../../+state/preferences/preferences.keys';
import { SuggesterSettings } from '../../models';
import { APPLICATION_SELECTED_SECURITY_KEY } from '../constants';
import { SelectedSecuritySettings } from '../models';

export const saveApplicationSelectedSecurityPreference = (data: SelectedSecuritySettings) =>
  saveSettings(SelectedSecuritySettings, { section: APPLICATION_SELECTED_SECURITY_KEY, data });

export const saveSuggesterSelectedSecurityPreference = (data: SuggesterSettings) =>
  saveSettings(SuggesterSettings, { section: APPLICATION_SUGGESTER_KEY, data });
